/* Система Sysupdate. */
/* Функция sysupdateBase() создает базовый объект oSysupdateBase для всех других объектов системы. */
/* Функция sysupdateBase(oWorkHandler) - инициализация базового класса. */
/* В качестве параметров принимаются: */
/* oWorkHandler - объект-контейнер для записи данных о ходе выполнения обновления */
function sysupdateBase(oParent, oWorkHandler, oInputParam)
{
	// Базовые функции sysupdate
	var oSysupdateBase =
	{
		oParent: null, // Объект главного oSysupdate.
		oWorkHandlerParent: null, // Основной для записи результата. Нужен для правильной прокрутки скролла вниз
		oWorkHandler: null, // Объект для записи результата,
		oSaveData: {}, // Сохраненные данные после первого ajax-запроса (Самое начало работы)
		oInputParam: {}, // Данные для динамики загрузки файла
		iMaxLength: 20, // Максимальная длина пути, который будет написан на кнопке для загрузки
		iWorkHandlerParent: 0, // Высота основного блока для записей
		ini: function(oParent, oWorkHandler, oInputParam)
		{
			this.oParent = oParent;
			this.oWorkHandlerParent = oWorkHandler;
			this.oWorkHandler = this.oWorkHandlerParent.find('div');
			this.iWorkHandlerParent = this.oWorkHandlerParent.height();
			this.oInputParam = oInputParam;

			this.oInputParam.oPrevButton.on('click', {this: this}, this.fileUpload);
			this.oInputParam.oPrevButton.tooltip();
			this.oInputParam.oInputFile.on('change', {this: this}, this.fileChange);
			return this;
		},
		fileUpload: function(e)
		{
			var $this = e.data.this;
			$this.oInputParam.oInputFile.trigger('click');
		},
		fileChange: function(e)
		{
			var $this = e.data.this,
				sName = $this.oInputParam.oInputFile.val().split('\\').pop();
			$this.oInputParam.oFileName.html("Загружен архив: <br><br><div data-original-title='"+sName+"'>" + $this.getCutName(sName) + "<hr>");
			$this.oInputParam.oFileName.find('div').tooltip();
			$this.oParent.oSysupdateServer.uploadNewArray($this.oParent);
		},
        getCutName: function(name)
        {
            return ( name.length > this.iMaxLength ) ? ( name.substring(0, this.iMaxLength) + '...' ) : name;
        },
		getContent: function(sData, sColor) // Собираем текст с помощью <span>
		{
			var aData 		= sData.split("<br>"),
				sResult 	= '',
				bDefault 	= (sColor != 'default'),
				sPrev 		= (bDefault) ? '<span class="label label-'+sColor+'">' : '',
				sAfter 		= (bDefault) ? '</span><br>' : '<br>';
			for( var i in aData ) sResult += sPrev+aData[i]+sAfter;
			return sResult;
		},
		html: function(sData, sColor) // Обновляем текст
		{
			if( this.oWorkHandler ) this.oWorkHandler.html(this.getContent(sData, sColor));
		},
		append: function(sData, sColor) // Добавляем текст в конец
		{
			if( this.oWorkHandler ) this.oWorkHandler.append(this.getContent(sData, sColor));
			this.oWorkHandlerParent.animate({ scrollTop: this.oWorkHandler.height() }, 0);
		},
		loading: function(bshow) // Полоса загрузки (добавть\удалить)
		{
			if( this.oWorkHandler )
			{
				if( bshow ){ this.oWorkHandler.append('<img class="sysupdate-load" src="/img/sysupdate-load.gif"><br>'); }
				else{ this.oWorkHandler.find('.sysupdate-load').remove(); }
			}
		},
		getActionName: function(i) // Получаем заголовки в зависимости от действия
		{
			var sName = '';
			switch(i)
			{
				case 'sql':
					sName = "Обновление базы данных.";
					break;
				case 'files':
					sName = "Обновление файлов методом копирования.";
					break;
				case 'patches':
					sName = "Обновление файлов с применением пачтей.";
					break;
				case 'command':
					sName = "Исполнение дополнительных команд.";
					break;
				case 'clients':
					sName = false;
					break;
			}
			return sName;
		},
		// Вытаскиваем первый элемент массива и возвращаем его с оставшимся массивом (либо undefined)
		getNewData: function(aaData)
		{
			var aaNewClients, aClient, j = 0;
			for( var i in aaData)
			{
				if( !parseInt(i) )
				{
					aClient = aaData[i];
				}
				else
				{
					if( !aaNewClients ) aaNewClients = [];
					aaNewClients[j] = aaData[i];
					j++;
				}
			}
			return [aClient, aaNewClients];
		},
        error: function (XMLHttpRequest, textStatus, errorThrownl) // стандарные параметры при ajax-запросе
        {
        	this.loading(false); // Убираем полосу ожидания
        	this.append("Серверная ошибка. Передайте сообщение об ошибке в службу поддержки.", "important");
			this.append("Ошибка от сервера: " + errorThrownl.message + ".", "important");
			this.append("Ошибочный ответ: "+ XMLHttpRequest.responseText, "important");
			this.saveInformation();
			return false;
		},
		// Во время ошибок при обновлении выполняются одинаковые действия
		// Все варианты таких действий собраны в одном месте
		// $this - Объект, котоый производит действия
		// operation - опреация из цикла
		// oParam - необходимые дополнительные параметры
		errorsHandler: function($this, operation, oParam)
		{
			this.loading(false); // Убираем полосу ожидания
			switch(operation)
			{
				case 1:
					if( oParam.iBrowseError )
					{
						$this.oSysupdateBase.append("Ошибка браузера "+oParam.iBrowseError+". Обратитесь в службу поддержки.", "important");
					}
					$this.addBad(oParam.sAlias);
	        		$this.oSysupdateBase.append("Ошибка при выполнении обновлений БД на сервере для '"+oParam.sUserName+"'.", oParam.sColor);
	        		$this.oSysupdateBase.append("Выполняем полную отмену изменений для '"+oParam.sUserName+"'.", oParam.sColor);
	        		$this.rollbackFullClient(oParam.aaClients, oParam.sIP, oParam.sDatabase, oParam.sUserName, oParam.sAlias, oParam.date, oParam.zipname);
					break;
				case 2:
					this.append("Ошибка отмены изменений БД объекта на сервере. Сообщите об этом в службу поддержки.", "important");
					break;
				case 3:
					this.append("Ошибка при восстановлении данных на стороне объекта.", "important");
	                this.append("Ошибка отмены изменений объекта. Сообщите об этом в службу поддержки.", "important");
					break;
				case 4:
					this.append("Ошибка браузера "+oParam+". Обратитесь в службу поддержки.", "important");
					break;
				case 5: // Ошибка 3 и 4 вместе
					this.append("Ошибка браузера "+oParam+". Обратитесь в службу поддержки.", "important");
					this.append("Ошибка при восстановлении данных на стороне объекта.", "important");
	                this.append("Ошибка отмены изменений объекта. Сообщите об этом в службу поддержки.", "important");
					break;
				case 6: // Ошибка 2 и 4 вместе
					this.append("Ошибка браузера "+oParam+". Обратитесь в службу поддержки.", "important");
					this.append("Ошибка отмены изменений БД объекта на сервере. Сообщите об этом в службу поддержки.", "important");
					break;
			}
			this.saveInformation();
		},
		// Сохраняем в файл все записи, которые выведены пользователю на экран
		saveInformation: function()
		{
			var $this = this,
				sContent = this.oWorkHandler.html(),
				formdata = (window.FormData) ? new FormData() : false;
				if( formdata )
				{
					formdata.append('ajax', 1);
					formdata.append('operation', 6);
					formdata.append('action_data', sContent);
					$.ajax({
			            	dataType: "json",
			                url: "/sysupdate",
			                type: "POST",
			                data: formdata,
			                processData: false,
			                contentType: false,
			                success: function (data)
			                {
			                	var sColor = "default";
			                	if( data.bResult )
			                	{
			                		$this.append("История браузера успешно сохранена.", sColor);
			                	}
			                	else
			                	{
			                		$this.append("Не удалось сохранить историю браузера.", sColor);
			                	}
			                },
				            error: function (XMLHttpRequest, textStatus, errorThrown)
				            {
				            	// Аналогично - все грустно.
				            	// Нет смысла в обработке.
							}
			            });
				}
				else
				{
					// Все печальнее некуда.
					// Нет смысла в обработке.
				}
		}
	}
	return oSysupdateBase.ini(oParent, oWorkHandler, oInputParam);
}